import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ExportOption } from '../_models/export-option';
import { ExportRequest } from '../_models/export-request';
import { saveAs } from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { ExportInProgressDialogComponent } from '../export-in-progress-dialog/export-in-progress-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ExportManagerService {

  public exportManagerWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public exportOptions: BehaviorSubject<Array<ExportOption>> = new BehaviorSubject<Array<ExportOption>>(null);

  constructor(
    private httpClient: HttpClient,
    private dialog: MatDialog
  ) {
    //Go ahead and load the options.
    this.getExportOptions();
  }

  protected getExportOptions() {

    var promise = new Promise((resolve, reject) => {
      this.exportManagerWorking.next(true);

      var url = "api/Export/exportOptions";

      this.httpClient.get(url).subscribe((result: Array<ExportOption>) => {
        this.exportManagerWorking.next(false);
        this.exportOptions.next(result);
      },
        (err) => {
          this.exportManagerWorking.next(false);
      });
    });

    return promise;
  }

  public exportCount(exportRequest: ExportRequest) {
    var promise = new Promise((resolve, reject) => {

      var url = "api/Export/count";

      this.httpClient.post(url, exportRequest).subscribe((result: any) => {
        resolve(result);
      });
    });

    return promise;
  }

  public export(exportRequest: ExportRequest, presentDialog: boolean): Promise<any> {
    var promise = new Promise((resolve, reject) => {

      var url = "api/Export";
      this.exportManagerWorking.next(true);

      if (presentDialog) {
        this.dialog.open(ExportInProgressDialogComponent, {
          disableClose: true
        });
      }
      

      this.httpClient.post(url, exportRequest, {
        responseType: "arraybuffer",
        observe: "response"
      }).subscribe((result: any) => {
        var headers = result.headers;

        var contentDisposition = headers.get('content-disposition');
        const r = /(?:filename=)(.+)(?:;)/;
        var regexResults = r.exec(contentDisposition);

        var filename = regexResults[1];

        var type = "text/plain";

        var blobdata = [new Uint8Array(result.body, 0, result.length)];

        var blob = new Blob(blobdata, { type: type });

        saveAs(blob, filename);

        //Close the dialog
        if (presentDialog) {
          this.dialog.closeAll();
        }

        resolve(null);
      },
        (error) => {
          this.exportManagerWorking.next(false);

          //Close the dialog
          if (presentDialog) {
            this.dialog.closeAll();
          }
      });
    });

    return promise;
  }
}
